import React, { useContext } from "react"
import { useHistory as useRouterHistory, useParams } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { useAccountingBookSummary, useAccountingBook, useIsDesktop } from '../hooks'
import { Loading, PaymentsHeader, SettleGroups } from '../components'
import { Context as AuthContext } from '../contexts/AuthContext'
import styles from './AccountingBookSummaryPage.module.scss'

const pageStyles = {
  bg: {
    width: '100%',
    maxWidth: '600px',
    margin: '0 auto',
    height: 'calc(100vh)',
    maxHeight: '-webkit-fill-available',
    overflow: 'hidden',
    display: 'flex',
    flexFlow: 'column',
  },
}

const AccountingBookSummaryPage = () => {
  const { state: authState } = useContext(AuthContext)
  const history = useRouterHistory()
  const isDesktop = useIsDesktop()
  // eslint-disable-next-line
  const [_cookies, setCookie] = useCookies(['payment'])
  // eslint-disable-next-line
  const [_users, accountingBookDetails] = useAccountingBook(authState)
  // eslint-disable-next-line
  const [summary, loading, _err, _get, _debt, settlements] = useAccountingBookSummary(authState)

  const symbol = accountingBookDetails.currency_symbol || '$'
  const exponent = accountingBookDetails.exponent || 0
  const { group_id, accounting_book_id } = useParams()
  const gid = group_id || accountingBookDetails.group_id
  const bid = accounting_book_id || accountingBookDetails.id

  // settle plan grouped by 收款者 (creditor)
  const groups = (summary || []).map((t) => ({
    payer: { id: t.payer_id, name: t.payer_display_name, img: t.payer_image_url },
    total: t.total,
    debts: (t.debts || []).map((d) => ({
      ower: { id: d.ower_id, name: d.ower_display_name, img: d.ower_image_url },
      amount: d.amount,
    })),
  }))

  // ower (還款者) pays payer (收款者) back
  const markPaid = (tr) => {
    setCookie('payment', {
      description: '還款',
      amount: tr.amount,
      paid_back: true,
      allocation_type: 'amount',
      payer_id: tr.from.id,
      ower_id: tr.to.id,
    }, { path: '/' })
    history.push(`/liff_entry/groups/${gid}/accounting_books/${bid}/payments/paid_back`)
  }

  const isEmpty = (settlements || []).length === 0

  return (
    <div style={isDesktop ? { ...pageStyles.bg, maxWidth: 'none', height: '100%' } : pageStyles.bg}>
      { !isDesktop && <PaymentsHeader accountingBookDetails={accountingBookDetails} backLink={`/liff_entry/groups/${gid}/accounting_books/${bid}/overview`} /> }

      {loading ? <Loading /> : (
        <div className={`${styles.scroll} ${isDesktop ? styles.desktopScroll : ''}`}>
          {isEmpty || groups.length === 0 ? (
            <div className={styles.allClear}>🎉 已全部結清</div>
          ) : (
            <>
              <div className={styles.sectionTitle}>分帳建議</div>
              <div className={styles.sectionSub}>以下是最簡單的結算方式，幫助大家快速還清款項</div>
              {isDesktop ? (
                <div className={styles.desktopGrid}>
                  {groups.map((g, i) => (
                    <SettleGroups
                      key={g.payer.id || i}
                      groups={[g]}
                      symbol={symbol}
                      exponent={exponent}
                      onMarkPaid={markPaid}
                      defaultOpen
                    />
                  ))}
                </div>
              ) : (
                <SettleGroups
                  groups={groups}
                  symbol={symbol}
                  exponent={exponent}
                  onMarkPaid={markPaid}
                  defaultOpen
                />
              )}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default AccountingBookSummaryPage
